import React from "react";
import StyledLink from "components/common/utils/StyledLink";
import { graphql, Link } from "gatsby";
import { Button } from "react-bootstrap";
import config from 'utils/siteConfig';
import Block from "../../Block";
import "./styles.sass";
import { useAirtableBlogCtaByBlockCode } from "hooks/useAirtableBlogCtas";
import { AirtableMarkdown } from "components/common/utils/AirtableMarkdown";

export const query = graphql`
  fragment BlogBlockShortCode on WpCoreShortcodeBlock {
    originalContent
    attributes {
      text
    }
  }
`;

class CoreShortCodeFactory {
  get type() {
    return "core/shortcode";
  }

  create(props) {
    const shortCode = props.block.attributes.text;
    const blogCta = useAirtableBlogCtaByBlockCode(shortCode)

    if(blogCta) {
      return (
        <div className="blog-post-consultation-block">
          <div className="blog-post-consultation-block-title">
            <p>{blogCta.data.bloc_title}</p>
          </div>
          <div className="blog-post-consultation-block-body flex-column">
            <p>
              <AirtableMarkdown markdown={blogCta.data.bloc_cta_bullets}/>
            </p>
            <Link to={blogCta.data.cta_url} rel="nofollow">
              <Button variant="black" className="text-white w-auto px-4">{blogCta.data.bloc_cta_label}</Button>
            </Link>
          </div>
        </div>
      )
    }
    else{
      return null
    }
  }
}

export default CoreShortCodeFactory;
